import { StatusStyleCode } from '../common'

export type IntegrationModule = {
    code: IntegrationModuleCode,
    name: string,
    color: StatusStyleCode,
}

export enum IntegrationModuleCode {
    APS = 'APS',
    MES = 'MES',
    Admin = 'Admin',
}

export const IntegrationModuleSpec: { [key in IntegrationModuleCode]: Omit<IntegrationModule, 'code'> } = {
    [IntegrationModuleCode.APS]: { name: 'APS', color : StatusStyleCode.Yellow },
    [IntegrationModuleCode.MES]: { name: 'MES', color : StatusStyleCode.Green },
    [IntegrationModuleCode.Admin]: { name: 'Admin', color : StatusStyleCode.Blue },
}

export type IntegrationMethod = {
    code: IntegrationMethodCode,
    value: string,
}

export enum IntegrationMethodCode {
    GET = 'get',
    POST = 'post',
    PUT = 'put',
    DELETE = 'delete',
}

export const IntegrationMethodSpec: { [key in IntegrationMethodCode]: Omit<IntegrationMethod, 'code'> } = {
    [IntegrationMethodCode.GET]: { value: 'get' },
    [IntegrationMethodCode.POST]: { value: 'post' },
    [IntegrationMethodCode.PUT]: { value: 'put' },
    [IntegrationMethodCode.DELETE]: { value: 'delete' },
}

